
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./GoldLoanReport.css";
import axios from "axios";
import { Edit, Trash } from "lucide-react";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50];

const API_URL = "https://payyug.in/api/"; 

const AppliedGoldLoan = () => {
  const navigate=useNavigate()

  const [filterData, setFilterData] = useState({
    fromDate: "",
    toDate: "",
    loanAccountNumber: "",
    userId: "",
    userName: "",
    loanStatus: "",
  });

  const [filteredLoans, setFilteredLoans] = useState([]);
  const [goldLoans,setGoldLoans]=useState([])
  const [loading,setLoading]=useState(false)
  const [error,setError]=useState(null)
    const [totalPages, setTotalPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);


  const handleChange = (e) => {
    setFilterData({ ...filterData, [e.target.name]: e.target.value });
  };

    /* ================= FETCH ================= */
    const fetchGoldLoans = async () => {
      try {
        setLoading(true)
        const res = await axios.get(
          `${API_URL}/gold-loan/list`,
          {
            params: {
              superAdminId: localStorage.getItem("adminuserId"),
              page: currentPage,
              limit: itemsPerPage,
            },
          },
        );
  
        setLoading(false)
        setGoldLoans(res.data.data);
        setTotalPages(res.data.totalPages);
      } catch (error) {
        setError(error.response.data.message||"Something went wrong")
        console.error("Fetch error:", error);
      }
    };
  
    useEffect(() => {
      fetchGoldLoans();
    }, [currentPage, itemsPerPage]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const filtered = goldLoans.filter((loan) => {
      const {
        fromDate,
        toDate,
        loanAccountNumber,
        userId,
        userName,
        loanStatus,
      } = filterData;
      const appliedDate = new Date(loan.appliedDate);

      return (
        (!fromDate || appliedDate >= new Date(fromDate)) &&
        (!toDate || appliedDate <= new Date(toDate)) &&
        (!loanAccountNumber ||
          loan.loanAccountNumber
            ?.toLowerCase()
            .includes(loanAccountNumber.toLowerCase())) &&
        (!userId || loan.userId?.toString() === userId) &&
        (!userName ||
          loan.userName?.toLowerCase().includes(userName.toLowerCase())) &&
        (!loanStatus || loan.status?.toLowerCase() === loanStatus.toLowerCase())
      );
    });

    setFilteredLoans(filtered);
    setCurrentPage(1);
  };

   const handleApproveLoan = async (loan) => {
    // Confirmation popup
    const confirmApprove = window.confirm(
      `Do you want to approve loan ${loan.loanAccountNumber}?`
    );
    if (!confirmApprove) return;

    if (loan.status?.toLowerCase() === "approved") {
      toast.info("Loan is already Approved");
      return;
    }

    try {
      const response = await axios.post(
        // `${API_URL}approveLoan-personal/${loan.id}/approve`,
        { approvalRemark: "Verified documents" }
      );

      toast.success(response.data.message);
      fetchGoldLoans();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to approve loan");
    }
  };

    /* ================= DELETE ================= */
    const handleDelete = async (id) => {
      if (!window.confirm("Are you sure you want to delete?")) return;
  
      try {
        await axios.delete(`${API_URL}/gold-loan/${id}`);
        toast.success("Loan Deleted Successfully");
        fetchGoldLoans();
      } catch (error) {
        toast.error(error?.response?.data?.message||`Error Deleting Loan ${error}`)
        console.error("Delete error:", error);
      }
    };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <div className="gold-loan-report-container">
      {/* Filter Section */}
      <section className="gold-loan-report-filterSection">
        <h2 className="gold-loan-report-title">Applied Loans Filter</h2>
        <p className="gold-loan-report-subtitle">
          Use filter to see more precise report
        </p>
        <form className="gold-loan-report-form" onSubmit={handleSubmit}>
          <div className="gold-loan-report-grid">
            <div className="gold-loan-report-formGroup">
              <label>From Date</label>
              <input type="date" name="fromDate" onChange={handleChange} />
            </div>
            <div className="gold-loan-report-formGroup">
              <label>To Date</label>
              <input type="date" name="toDate" onChange={handleChange} />
            </div>
            <div className="gold-loan-report-formGroup">
              <label>Loan Account Number</label>
              <input
                type="text"
                name="loanAccountNumber"
                placeholder="Loan account number"
                onChange={handleChange}
              />
            </div>
            {/* <div className="gold-loan-report-formGroup">
              <label>Applicant User ID</label>
              <input
                type="text"
                name="userId"
                placeholder="Applicant user id"
                onChange={handleChange}
              />
            </div> */}
            <div className="gold-loan-report-formGroup">
              <label>Applicant User Name</label>
              <input
                type="text"
                name="userName"
                placeholder="Applicant user name"
                onChange={handleChange}
              />
            </div>
            <div className="gold-loan-report-formGroup">
              <label>Choose Loan Status</label>
              <select name="loanStatus" onChange={handleChange}>
                <option value="">Select loan status</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
                <option value="Closed">Closed</option>
              </select>
            </div>
          </div>
          <button type="submit" className="gold-loan-report-submitBtn">
            Submit
          </button>
        </form>
      </section>

      {/* Loan Details Section */}
      <section className="gold-loan-report-detailsSection">
        <div className="gold-loan-report-tableHeader">
          <div>
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
          <input
            type="text"
            placeholder="Search..."
            className="gold-loan-report-searchInput"
          />
        </div>

        <div className="gold-loan-report-tableContainer">
          <table className="gold-loan-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Loan Account Number</th>
                <th>Loan Type</th>
                <th>Loan Service</th>
                <th>Loan Amount</th>
                <th>Loan Tenure</th>
                <th>Loan Roi</th>
                <th>Loan Recovery Frequency</th>
                <th>Net Weight</th>
                <th>Market Rate</th>
                <th>LTV (%)</th>
                <th>Applied Date</th>
                <th>Disbursal Mode</th>
                {/* <th>View Emi</th> */}
                <th>View Card</th>
                <th>Kyc Status</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="17">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="17">Error: {error}</td>
                </tr>
              ) : goldLoans.length === 0 ? (
                <tr>
                  <td colSpan="17">No data available</td>
                </tr>
              ) : (
                goldLoans.map((loan, index) => {
                  return(
                  <tr key={loan.id}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{loan.loanAccountNumber||"N/A"}</td>
                    <td>{loan.loanType||"N/A"}</td>
                    <td>{loan.loanService||"N/A"}</td>
                    <td>{loan.loanAmount||"N/A"}</td>
                    <td>{loan.loanTenure||"N/A"}</td>
                    <td>{loan.loanRoi||"N/A"}</td>
                    <td>{loan.loanRecoveryFrequency||"N/A"}</td>
                    <td>{loan.netWeight||"N/A"}</td>
                    <td>{loan.marketRate||"N/A"}</td>
                    <td>{loan.ltvPercent||"N/A"}</td>
                    <td>{loan.appliedDate?new Date(loan.appliedDate).toLocaleDateString("en-GB"):"N/A"}</td>
                    <td>{loan.loanDisbursalMode||"N/A"}</td>
                    {/* <td>
                      <button
                        onClick={() => navigate(`/GoldLoanViewEmi/${loan.id}` ,
                          {state:loan}
                        )}
                      >
                        View EMI
                      </button>
                    </td> */}
                    <td>
                       <button
                        onClick={() => navigate(`/GoldLoanCard/${loan.id}`,{state:loan})}
                      >
                        Loan Card
                      </button>
                    </td>
                    <td>{loan.kycStatus||"N/A"}</td>
                    <td>{loan.status||"N/A"}</td>
                    {/* <td>
                      <div className="gold-loan-report-action-btns">
                      <button className="loan-delete-btn" onClick={()=>handleDelete(loan.id)}><Trash/></button>
                      </div>
                    </td> */}
                     <td>
                      <button
                        onClick={() => handleApproveLoan(loan)}
                        style={{
                          marginLeft: "6px",
                          background: "#1f8b94ff",
                          color: "#fff",
                          padding: "5px 10px",
                          border: "none",
                          borderRadius: "4px",
                        }}
                      >
                        Approve Loan
                      </button>
                    </td>
                  </tr>
                )})
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="gold-loan-report-pagination">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => prev - 1)}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((prev) => prev + 1)}
            >
              Next
            </button>
          </div>
        )}
      </section>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default AppliedGoldLoan;
